import { setConsultState, setPermissionStep } from '../actions';

export const getPermissions = async dispatch => {
  try {
    // Query for camera and microphone permissions directly
    const micPermission = await navigator.permissions.query({ name: 'microphone' });
    const camPermission = await navigator.permissions.query({ name: 'camera' });

    const hasAllPermissions = micPermission.state === 'granted' && camPermission.state === 'granted';

    // If either permission needs to be prompted for
    const shouldAskForPermission = micPermission.state === 'prompt' || camPermission.state === 'prompt';

    if (hasAllPermissions) {
      dispatch(setConsultState('pre-consult'));
    } else if (shouldAskForPermission) {
      dispatch(setPermissionStep('prompt'));
    } else {
      // Handle the 'denied' state: one or both permissions were blocked by the user.
      console.error('Permission was denied. Please enable it in browser settings.');
      dispatch(setPermissionStep('denied'));
    }
  } catch (error) {
    console.error('Failed to query media permissions:', error);
    // This can happen if the browser doesn't support the Permissions API
    // or for other reasons.
  }
};

export const getDevices = () => {
  navigator.mediaDevices.enumerateDevices();
};
